import { combineReducers } from 'redux';
import authReducer from './auth';
import appReducer from './app';

const rootReducer = combineReducers({
    authReducer: authReducer,
    appReducer: appReducer
});

export default rootReducer;